import React from 'react';
import PropTypes from 'prop-types';

// Components
import { MapLayerWrapper as Layer } from '../../Common';

// Constants
import { LAYERS } from '../Constants';

// Theme & Utils
import { colors } from '../../../Core/Theme';
import { createHash } from '../../../Core/Utils';

// Layer properties
const fillProperties = {
  id: LAYERS.RESERVABLE_DESK,
  type: 'fill',
  source: 'features',
  paint: {
    'fill-color': [
      'case',
      ['==', ['feature-state', 'idHover'], ['get', 'associatedFeature']],
      colors.palette.primary.main,
      ['boolean', ['feature-state', 'hover'], false],
      colors.palette.primary.light,
      colors.palette.primary.main,
    ],
  },
};

const lineProperties = {
  id: `${LAYERS.RESERVABLE_DESK}-lines`,
  type: 'line',
  source: 'features',
  paint: {
    'line-color': colors.palette.primary.main,
    'line-width': 1,
  },
};

// Legend
const legend = {
  key: LAYERS.RESERVABLE_DESK,
  style: {
    backgroundColor: colors.palette.primary.main,
    borderColor: colors.palette.primary.main,
    borderWidth: 2,
    borderStyle: 'solid',
  },
  labelKey: 'deskFloorPlan.legend.reservableDesk',
};

const ReservableDesk = props => {
  const { desks } = props;
  return (
    <Layer
      key={`${LAYERS.RESERVABLE_DESK}-${createHash(desks)}`}
      properties={[fillProperties, lineProperties]}
      filter={['in', ['get', 'id'], ['literal', desks]]}
      {...props}
    />
  );
};

ReservableDesk.defaultProps = {
  desks: [],
};
ReservableDesk.propTypes = {
  desks: PropTypes.arrayOf(PropTypes.string),
};

export { legend };
export default React.memo(ReservableDesk);
